import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const aflt_skillList = (request) => {
    let ENDPOINT = '';
    if(request.data!==undefined){      
      let pageId = request.data.page;
      let column = request.data.column;
      let pageSize = request.data.pageSize;
      let affId = request.data.affId;
      let clientId = request.data.clientId;
      let shiftId = request.data.shiftId ? request.data.shiftId : 0; 
      let departmentId = request.data.departmentId ? request.data.departmentId : 0; 
      if(column||pageId || affId || clientId){  
        ENDPOINT = URL_BASE_API+'affiliate/skills/?page='+pageId+'&column='+column+'&page_size='+pageSize;
      }
      if(affId|| clientId){
        ENDPOINT = URL_BASE_API+'affiliate/skills/?page='+pageId+'&column='+column+'&page_size='+pageSize+'&affiliate='+affId+'&client='+clientId;
        if(shiftId) {
            ENDPOINT += '&shift_id='+shiftId; 
        }
        if(departmentId) ENDPOINT += '&department='+departmentId;
      }
      
    }else{
      ENDPOINT = URL_BASE_API+'affiliate/skills/';
    }
    return service.get(ENDPOINT);    
};

export const aflt_skillAdd = (request) => {
  // const ENDPOINT = URL_BASE_API+'affiliate/skills/';  
  const ENDPOINT = URL_BASE_API+'affiliate/skills_v2/';  // ADDED ON 12Aug2022
  return service.post(ENDPOINT,request.data);  
};

export const aflt_skillEdit = (request) => {
  let skillId = request.data;
  const ENDPOINT = URL_BASE_API+'affiliate/skills/'+skillId;

  return service.get(ENDPOINT);  
};

export const aflt_skillUpdate = (request) => {
  let skillId = request.data.id;
  const ENDPOINT = URL_BASE_API+'affiliate/skills/'+skillId;

  return service.put(ENDPOINT,request.data);
};

export const aflt_skillDelete = (request) => {
  let skillId = request.data.skillId;
  let confirm = request.data.confirm;
  let ENDPOINT = '';
  if(confirm!==undefined){
    ENDPOINT = URL_BASE_API+'affiliate/skills/'+skillId+'?delete_confirmation='+confirm;
  }else{
    ENDPOINT = URL_BASE_API+'affiliate/skills/'+skillId;
  }

  return service.delete(ENDPOINT);  
};  

export const updateSkillIndex = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/update-skill-indexing/';
  return service.put(ENDPOINT,request.data); 
}; 

export const skillSuggestion = (request) => {
  let skill = request.data;
  const ENDPOINT = URL_BASE_API+'super-admin/skill-suggestions/?search='+skill;
  return service.get(ENDPOINT);  
};

